// components/SelectInput.tsx
import React from "react";

interface SelectInputProps {
  id: string;
  name: string;
  label: string; // Add label prop for display text
  value: string;
  options: { value: string; label: string }[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectInput: React.FC<SelectInputProps> = ({
  id,
  name,
  label, // Use the new label prop
  value,
  options,
  onChange,
}) => {
  return (
    <div className="mb-5 w-full">
      <label htmlFor={id} className="block text-sm text-gray-400 mb-2">
        {label} {/* Use label for display */}
      </label>
      <select
        id={id}
        name={name} // Keep name for formState mapping
        required
        value={value}
        onChange={onChange}
          className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
      >
        <option value="" className="bg-[#959ca6] text-white">
          {label} {/* Use label for default option text */}
        </option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            className="bg-[#959ca6] hover:bg-[#6b727a] text-black"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInput;
